/**
 * Basic formatter for languages with brace-based syntax (C#, Go, Rust, etc.)
 * @param {string} code - Code to format
 * @param {number} indentSize - Number of spaces per indent level
 * @returns {string} Formatted code
 */
export const formatBraceBasedCode = (code, indentSize = 2) => {
  const lines = code.split("\n");
  const formattedLines = [];
  let indentLevel = 0;

  for (const line of lines) {
    const trimmedLine = line.trim();
    if (trimmedLine === "") {
      formattedLines.push("");
      continue;
    }

    // Handle closing braces/brackets
    if (trimmedLine.startsWith("}") || trimmedLine.startsWith("]")) {
      indentLevel = Math.max(0, indentLevel - 1);
    }

    const indent = " ".repeat(indentLevel * indentSize);
    formattedLines.push(indent + trimmedLine);

    // Handle opening braces/brackets
    if (trimmedLine.endsWith("{") || trimmedLine.endsWith("[")) {
      indentLevel++;
    }
  }

  return formattedLines.join("\n");
};

/**
 * Generic basic indentation formatter (fallback for languages without specific formatters)
 * @param {string} code - Code to format
 * @param {number} indentSize - Number of spaces per indent level
 * @returns {string} Formatted code
 */
export const formatBasicIndentation = (code, indentSize = 2) => {
  const lines = code.split("\n");
  const formattedLines = [];
  let indentLevel = 0;

  for (const line of lines) {
    const trimmedLine = line.trim();
    if (trimmedLine === "") {
      formattedLines.push("");
      continue;
    }

    // Basic dedent detection
    if (trimmedLine.match(/^(end|else|elsif|fi|done|esac|})\s*$/)) {
      indentLevel = Math.max(0, indentLevel - 1);
    }

    const indent = " ".repeat(indentLevel * indentSize);
    formattedLines.push(indent + trimmedLine);

    // Basic indent detection
    if (
      trimmedLine.match(/(\{|\(|\[|if|for|while|def|class|module|begin|do)\s*$/)
    ) {
      indentLevel++;
    }
  }

  return formattedLines.join("\n");
};

